import React, { useState } from "react";
import { X, UserCog, Trash2, ShieldAlert, Pencil } from "lucide-react";
import EditAccountForm from "./EditAccountForm";

// Popup per gestire gli account di posta aggiunti (modifica ed eliminazione) e il profilo di accesso
export default function DeleteAccountModal({ open, onClose, accounts, onDeleteAccount, onAccountUpdated, user, onDeleteProfile }) {
  const [editId, setEditId] = useState(null);
  const chiudi = () => {
    setEditId(null);
    onClose();
  };
  return (
    <div className={`wf-modal-backdrop ${open ? "show" : ""}`} onClick={chiudi}>
      <div className="wf-modal ctx-modal gestisci-account" onClick={(e) => e.stopPropagation()} data-testid="delete-account-modal">
        <div className="wf-modal-head">
          <span className="wf-modal-title">
            <UserCog size={19} strokeWidth={2.3} /> Gestisci account
          </span>
          <button className="icon-btn" onClick={chiudi} aria-label="Chiudi" data-testid="delete-account-close">
            <X size={20} strokeWidth={2.6} />
          </button>
        </div>

        <div className="ctx-sub" style={{ margin: "0 0 10px" }}>
          Account di posta aggiunti — la matita apre la modifica
        </div>

        {accounts.length === 0 ? (
          <div style={{ fontSize: 13.5, fontWeight: 700, color: "var(--ink-soft)", padding: "6px 2px 14px" }}>
            Nessun account aggiunto.
          </div>
        ) : (
          <div style={{ display: "flex", flexDirection: "column", gap: 8, marginBottom: 14 }}>
            {accounts.map((a) => (
              <div key={a.id} className={`del-acc-blocco ${editId === a.id ? "aperto" : ""}`}>
                <div className="del-acc-row" data-testid={`del-row-${a.id}`}>
                  <span className={`chip ${a.tipo === "pec" ? "chip-pec" : ""}`} style={{ cursor: "default", borderColor: a.colore, background: editId === a.id ? a.colore : undefined, color: editId === a.id ? "#fff" : undefined }}>
                    {a.label}
                  </span>
                  <span className="del-acc-email">
                    {a.email}
                    {a.imap_host ? <small> · {a.protocollo === "pop3" ? "POP3" : "IMAP"} {a.imap_host}</small> : null}
                  </span>
                  <button
                    className={`icon-btn del-acc-btn edit-acc-btn ${editId === a.id ? "on" : ""}`}
                    onClick={() => setEditId(editId === a.id ? null : a.id)}
                    aria-label={"Modifica " + a.email}
                    title="Modifica questo account"
                    data-testid={`edit-btn-${a.id}`}
                  >
                    <Pencil size={17} strokeWidth={2.3} />
                  </button>
                  <button
                    className="icon-btn del-acc-btn"
                    onClick={() => onDeleteAccount(a.id)}
                    aria-label={"Elimina " + a.email}
                    title="Elimina questo account"
                    data-testid={`del-btn-${a.id}`}
                  >
                    <Trash2 size={18} strokeWidth={2.3} />
                  </button>
                </div>
                {editId === a.id && (
                  <EditAccountForm
                    account={a}
                    onCancel={() => setEditId(null)}
                    onSaved={(acc) => {
                      onAccountUpdated?.(acc);
                      setEditId(null);
                    }}
                  />
                )}
              </div>
            ))}
          </div>
        )}

        <div className="del-profile-box">
          <div style={{ display: "flex", alignItems: "center", gap: 8, fontWeight: 800, fontSize: 13.5 }}>
            <ShieldAlert size={17} strokeWidth={2.3} color="var(--danger)" />
            Profilo di accesso
          </div>
          <div style={{ fontSize: 12.5, fontWeight: 600, color: "var(--ink-soft)", margin: "6px 0 10px" }}>
            {user?.email} — eliminando il profilo dovrai registrarti di nuovo.
          </div>
          <button className="wf-btn del-profile-btn" onClick={onDeleteProfile} data-testid="delete-profile-btn">
            <Trash2 size={15} strokeWidth={2.4} /> Elimina il mio profilo
          </button>
        </div>
      </div>
    </div>
  );
}
